import EFPicture from '@elem/compCommon/EFPicture';
import Phone from '@elem/SVGIcon/PowerBackup/Phone';
import WaterPump from '@elem/SVGIcon/VanlifeRoadtrips/WaterPump';
import WiFiRouter from '@elem/SVGIcon/PowerBackup/WiFiRouter';
import Laptop from '@elem/SVGIcon/PowerBackup/Laptop';
import CarFridge from '@elem/SVGIcon/VanlifeRoadtrips/CarFridge';
import Mixer from '@elem/SVGIcon/VanlifeRoadtrips/Mixer';
import Oven from '@elem/SVGIcon/VanlifeRoadtrips/Oven';
import AirConditioner from '@elem/SVGIcon/PowerBackup/AirConditioner';
import CoffeeMaker from 'elem/SVGIcon/PowerBackup/CoffeeMaker';
import Microwave from '@elem/SVGIcon/PowerBackup/Microwave';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function K() {
    const { useLang, useRouter, useState, Link } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const [open, setOpen] = useState(false);

    const IMG_MAP: any = {
        us: {
            pk5: 'https://websiteoss.ecoflow.com/upload/image/1731046528319/pk_5kw.png',
            pk15: 'https://websiteoss.ecoflow.com/upload/image/1731046248873/pk_15kw.png',
            pk45: 'https://websiteoss.ecoflow.com/upload/image/1731046248615/pk_45kw.png',
        },
        default: {
            pk5: '/responsive/picture/common-products/powerkit_2kw.png',
            pk15: '/responsive/picture/common-products/powerkit_5kw.png',
            pk45: '/responsive/picture/common-products/powerkit_10kw.png',
        },
    };
    const IMG = IMG_MAP[locale] || IMG_MAP.default;
    const cards: any = [
        {
            img: IMG.pk5,
            title: t('secK_card1_title'),
            type: t('secK_card1_type'),
            days: t('secK_card1_days'),
        },
        {
            img: IMG.pk15,
            title: t('secK_card2_title'),
            type: t('secK_card2_type'),
            days: t('secK_card2_days'),
        },
        {
            img: IMG.pk45,
            title: t('secK_card3_title'),
            type: t('secK_card3_type'),
            days: t('secK_card3_days'),
        },
    ];

    const icons: any = [
        {
            icon: <Phone />,
            text: t('secK_icon1_text'),
        },
        {
            icon: <WaterPump />,
            text: t('secK_icon2_text'),
        },
        {
            icon: <WiFiRouter />,
            text: t('secK_icon3_text'),
        },
        {
            icon: <Laptop />,
            text: t('secK_icon4_text'),
        },
        {
            icon: <CarFridge />,
            text: t('secK_icon5_text'),
        },
        {
            icon: <Mixer />,
            text: t('secK_icon6_text'),
        },
        {
            icon: <Oven />,
            text: t('secK_icon7_text'),
        },
        {
            icon: <AirConditioner />,
            text: t('secK_icon8_text'),
        },
        {
            icon: <CoffeeMaker />,
            text: t('secK_icon9_text'),
        },
        {
            icon: <Microwave />,
            text: t('secK_icon10_text'),
        },
    ];

    const linkLearn = locale == 'us' ? '/power-kits-5kva-48v-power-system' : '/ecoflow-power-kits/series';
    const linkQuote = locale == 'us' ? '/power-kits-5kva-48v-power-system?quote=1' : '/ecoflow-power-kits/series/get-a-quote';

    return (
        <div id="vanlife-roadtrips-K" className={`vanlife-roadtrips-K ${css['vanlife-roadtrips-K']}`}>
            <div className="ef-box">
                <div className="box-content">
                    <div className="left-part">
                        <p className="title">{t('secK_title')}</p>
                        <p className="type row-title">{t('secK_type')}</p>
                        <p className="days row-title">{t('secK_days')}</p>
                        {open && <p className="power row-title">{t('secK_power')}</p>}
                    </div>
                    <div className="right-part">
                        <ul className="cards">
                            {cards?.map((card: any, k: number) => (
                                <li className={`card card${k + 1}`} key={k}>
                                    <div className="title-box">
                                        <EFPicture src={card?.img} alt={card?.title} />
                                        <p className="card-title">{card?.title}</p>
                                    </div>
                                    <p className="card-type card-text">{card?.type}</p>
                                    <p className="card-days  card-text">{card?.days}</p>
                                </li>
                            ))}
                        </ul>
                        <ul className={`icons${open ? ' open' : ''}`}>
                            {icons?.map((icon: any, k: number) => (
                                <li className="icon" key={k}>
                                    {icon?.icon}
                                    <p className="icon-text">{icon?.text}</p>
                                </li>
                            ))}
                        </ul>
                        {!open && (
                            <span className="card-arrow" onClick={() => setOpen(true)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                                    <path d="M1.5 1L4.5 4L7.5 1" stroke="#AEAEAE" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </span>
                        )}
                        <div className="buy-btns">
                            <Link
                                className="btn-more card-btn"
                                href={linkLearn}
                                target="_blank"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'select_product',
                                    list_name: t('secK_title'),
                                    product_name: t('secK_title'),
                                    button_name: t('common_card_more'),
                                }}
                            >
                                {t('secA_btn')}
                            </Link>
                            {!['za', 'au', 'kr'].includes(locale) && (
                                <Link
                                    className="btn-quote card-btn"
                                    href={linkQuote}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'select_product',
                                        list_name: t('secK_title'),
                                        product_name: t('secK_title'),
                                        button_name: t('common_card_more'),
                                    }}
                                >
                                    {t('secK_quote')}
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="h5-wrapper">
                <p className="title">{t('secK_title')}</p>
                <div className="img-box">
                    {cards?.map((card: any, k: number) => (
                        <div className={`img-item img${k + 1}`} key={k}>
                            <EFPicture src={card?.img} alt={card?.title} />
                            <p className="card-title">{card?.title}</p>
                        </div>
                    ))}
                </div>
                <div className="type-box row-box">
                    <p className="type row-title">{t('secK_type')}</p>
                    <div className="flex-box">
                        {cards?.map((card: any, k: number) => (
                            <div className="column-item" key={k}>
                                {card?.type}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="days-box row-box">
                    <p className="days row-title">{t('secK_days')}</p>
                    <div className="flex-box">
                        {cards?.map((card: any, k: number) => (
                            <div className="column-item" key={k}>
                                {card?.days}
                            </div>
                        ))}
                    </div>
                </div>
                {!open && (
                    <span className="card-arrow" onClick={() => setOpen(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                            <path d="M1.5 1L4.5 4L7.5 1" stroke="#AEAEAE" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                )}
                {open && (
                    <div className="power-box row-box">
                        <p className="power row-title">{t('secK_power')}</p>
                        <ul className="icons">
                            {icons?.map((icon: any, k: number) => (
                                <li className="icon" key={k}>
                                    {icon?.icon}
                                    <p className="icon-text">{icon?.text}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                <div className="card-btns">
                    <Link
                        className="btn-more card-btn"
                        href={linkLearn}
                        target="_blank"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'select_product',
                            list_name: t('secK_title'),
                            product_name: t('secK_title'),
                            button_name: t('common_card_more'),
                        }}
                    >
                        {t('common_card_more')}
                    </Link>
                    {!['za', 'au', 'kr'].includes(locale) && (
                        <Link
                            className="btn-quote card-btn"
                            href={linkQuote}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'select_product',
                                list_name: t('secK_title'),
                                product_name: t('secK_title'),
                                button_name: t('common_card_more'),
                            }}
                        >
                            {t('secK_quote')}
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}
